import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'

import Dialog from './Dialog'
import GridCheckbox from './GridCheckbox'
import GridCircularProgress from './GridCircularProgress'
import { useGetCalendariBySquadraQuery } from '../hooks/api-slice'
import { config } from '../settings/configs'
import { titlesIscrizioni } from '../settings/settings'

const DialogDeleteIscrizione = ({
  open,
  handleClose,
  triggerFunction,
  team,
}) => {
  const { admin } = useSelector(state => state.home.infoUtente)

  const [deleteAlsoGare, setDeleteAlsoGare] = useState()

  const { data: gare, isFetching } = useGetCalendariBySquadraQuery(team?._id, {
    skip: !(admin && team?._id),
  })

  const numeroGare = gare?.length

  useEffect(() => {
    setDeleteAlsoGare()
  }, [open])

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      triggerFunction={() => triggerFunction(team?._id, deleteAlsoGare)}
      title={titlesIscrizioni.titleDelete}
      textUndo='Annulla'
      textConfirm='Ok'
      error
    >
      {!admin ? null : !team ? (
        'Nessuna squadra selezionata.'
      ) : isFetching ? (
        <GridCircularProgress />
      ) : !config?.features?.calendari ? null : numeroGare === 0 ? (
        'Questa squadra non è coinvolta in nessuna partita.'
      ) : (
        <Grid container spacing={2} sx={{ width: '100%' }}>
          <Grid size={12}>
            Questa squadra è coinvolta in {numeroGare}{' '}
            {numeroGare === 1 ? 'partita' : 'partite'}.
          </Grid>
          <GridCheckbox
            label='Elimina anche le partite.'
            value={!!deleteAlsoGare}
            onChange={(_, x) => setDeleteAlsoGare(x)}
            md={12}
          />
        </Grid>
      )}
    </Dialog>
  )
}

export default DialogDeleteIscrizione
